const ReactNativeStaticConfigs = /* @__PURE__ */ new WeakMap();
function getReactNativeConfig(Component) {
  return ReactNativeStaticConfigs.get(Component);
}
function setupReactNative(rnExports) {
  for (const key in rnExports) {
    if (key[0].toLowerCase() === key[0])
      continue;
    const val = rnExports[key];
    if (val && typeof val === "object") {
      ReactNativeStaticConfigs.set(val, {
        isReactNative: true,
        isText: key === "Text" || key === "TextInput",
        isInput: key === "TextInput" || key === "TextArea",
        inlineProps: key === "Image" ? /* @__PURE__ */ new Set(["src", "width", "height"]) : void 0
      });
    }
  }
}
export {
  ReactNativeStaticConfigs,
  getReactNativeConfig,
  setupReactNative
};
//# sourceMappingURL=setupReactNative.js.map
